import { Microscope, Lightbulb, TrendingUp, FileText } from "lucide-react"

export default function ResearchInnovations() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-primary text-white py-12 md:py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">Research and Innovations</h1>
          <p className="text-lg md:text-xl text-white/90">Pioneering Healthcare Solutions</p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="bg-white rounded-xl shadow-sm p-6 md:p-8 mb-8">
          <img src="/images/ResearchExcellence.png" alt="Research Excellence" className="w-full h-auto max-h-80 object-contain rounded-lg mb-6" />
          <h2 className="text-2xl md:text-3xl font-bold mb-4">Advancing Women's & Children's Healthcare</h2>
          <p className="text-gray-600 mb-6">
            At Pranaam Hospitals, we are dedicated to advancing medical research in maternal and child health. 
            Our research initiatives focus on improving patient outcomes, developing innovative treatment protocols, 
            and contributing to the global body of medical knowledge.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 mb-8">
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
              <Microscope className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-xl font-bold mb-3">Clinical Research</h3>
            <p className="text-gray-600">Conducting clinical trials and studies in obstetrics, gynecology, and pediatrics</p>
          </div>

          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
              <Lightbulb className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-xl font-bold mb-3">Innovation</h3>
            <p className="text-gray-600">Implementing cutting-edge medical technologies and treatment methods</p>
          </div>

          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
              <TrendingUp className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-xl font-bold mb-3">Quality Improvement</h3>
            <p className="text-gray-600">Continuous research to enhance patient care and safety standards</p>
          </div>

          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
              <FileText className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-xl font-bold mb-3">Publications</h3>
            <p className="text-gray-600">Contributing to medical journals and conferences worldwide</p>
          </div>
        </div>
      </div>
    </div>
  )
}
